import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "hardware-view"
}
const _hoisted_2 = { class: "hardware-name" }
const _hoisted_3 = ["textContent"]
const _hoisted_4 = ["textContent"]
const _hoisted_5 = { key: 0 }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h3", null, "Properties", -1)
const _hoisted_7 = { class: "properties" }

import { computed, onMounted, onUnmounted } from 'vue';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
import { Actions, Mutations } from '@/store';
import { HardwareComponent, TypeLabel } from '@/models/hardware.model';
import { formatDate } from '@/core/filters';
import Property from '@/components/system/components/Property.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'HardwareComponentView',
  setup(__props) {

const store = useStore();
const route = useRoute();

const componentTypes = computed<TypeLabel[]>(
  () => store.state.hardwareConfiguration.componentTypes,
);

const propertyTypes = computed<TypeLabel[]>(
  () => store.state.hardwareConfiguration.propertyTypes,
);

const item = computed<HardwareComponent>(() => store.state.item);

onMounted(() => {
  store.dispatch(Actions.GetHardwareConfiguration);
  if (!store.state.item) {
    store.dispatch(Actions.GetHardwareComponentByName, route.params.title);
  }
});

onUnmounted(() => {
  store.commit(Mutations.SetViewItem, null);
});

const getComponentLabel = (v: string) => {
  return componentTypes.value.find((i) => i.value === v)?.label || `(${v})`;
};
const getPropertyLabel = (v: string) => {
  return propertyTypes.value.find((i) => i.value === v)?.label || `(${v})`;
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_unref(item))
    ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h2", {
            textContent: _toDisplayString(_unref(item).name)
          }, null, 8, _hoisted_3),
          _createElementVNode("p", {
            class: "type",
            textContent: _toDisplayString(getComponentLabel(_unref(item).type))
          }, null, 8, _hoisted_4)
        ]),
        _createElementVNode("h3", null, _toDisplayString(_unref(formatDate)(_unref(item).date)), 1),
        (_unref(item).properties && _unref(item).properties.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("ul", _hoisted_7, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(item).properties, (prop) => {
                  return (_openBlock(), _createBlock(Property, {
                    key: prop.type,
                    component: _unref(item),
                    property: prop.type,
                    label: getPropertyLabel(prop.type)
                  }, null, 8, ["component", "property", "label"]))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_router_link, { to: "/hardware" }, {
          default: _withCtx(() => [
            _createTextVNode("Back")
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          to: '/hardware/' + _unref(item).url + '/edit'
        }, {
          default: _withCtx(() => [
            _createTextVNode("Edit")
          ]),
          _: 1
        }, 8, ["to"])
      ]))
    : _createCommentVNode("", true)
}
}

})